import { Route } from '@angular/router';
import { AuthGuard } from '$synapse/core';
import { Roles } from '$synapse/models';
import { CandidateDetailsComponent } from './candidate-details.component';
import { CandidateDetailsResolver } from './candidate-details-resolver';

export const CANDIDATE_DETAILS_ROUTES: Route[] = [
  {
    path: 'candidates/:id',
    component: CandidateDetailsComponent,
    canActivate: [AuthGuard],
    data: { roles: [Roles.MANAGER] },
    resolve: {
      candidates: CandidateDetailsResolver,
    },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
];
